import type { Country } from '@gozoki/api-types'

export const firstLetter = (str: string) => str.slice(0, 1)

export const includesLowerCase = (str: string, search: string) =>
  str.toLowerCase().includes(search.toLowerCase())

/** Replace comma with point, in order to parse French number notation */
export const toInternationalNumber = (str: string) => str.replace(',', '.')

export const isNumber = (value: string) => {
  const parsedValue = parseFloat(toInternationalNumber(value))
  if (!Number.isNaN(parsedValue)) {
    return true
  }
  return false
}

/** Parse French float notation */
export const parseFrenchFloat = (str: string) => parseFloat(toInternationalNumber(str))

/** Create a string from a price */
export const priceToString = (price: number, suffix = '') => {
  let strPrice = price.toFixed(2)
  strPrice = strPrice.replace('.', ',') // Use French notation

  return `${strPrice}€${suffix}`
}

export const capitalizeFirstLetter = (str: string) => str.charAt(0).toUpperCase() + str.slice(1)

export const removeTrailingSlash = (str: string): string => {
  if (str.endsWith('/')) {
    return str.slice(0, -1)
  }
  return str
}

export const getCountryLabel = (country: Country): string => {
  switch (country) {
    case 'FRANCE': {
      return 'France'
    }
    default: {
      return country
    }
  }
}

/**
 * Parses the French department code embedded at the start of a store label
 * (e.g. "33 - Tourny" -> "33", "2A - Ajaccio" -> "2A").
 * Returns null if the label does not follow that convention.
 */
export const parseDepartmentFromStoreLabel = (label: string): string | null => {
  const match = /^\s*(2A|2B|\d{1,2})\s*-/i.exec(label)
  if (!match) {
    return null
  }
  return match[1].toUpperCase()
}
